import styled from '@emotion/styled';
import { setMargin } from 'helpers';

export const PageWrapper = styled.div`
  display: flex;
  justify-content: start;
  flex-direction: column;
  width: 100%;
`;

export const LinkWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const IconWrapper = styled.div`
  cursor: pointer;
  background: ${({ theme }) => theme.colors.neutralLightNew};
  box-shadow: ${({ theme }) => theme.shadows.elevation1};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  transition: background-color 300ms linear, color 300ms linear,
    opacity 300ms linear;
  :active {
    opacity: 0.9;
    background-color: ${({ theme }) => theme.colors.neutralMain};
    transform: translateY(1px) scale(0.99);
  }
`;
export const Card = styled.div`
  ${setMargin};
  width: 100%;
  background: ${({ clear, theme, bg }) =>
    clear ? 'transparent' : theme.colors[bg]};
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => `${theme.spacings[6]}`};
  border-width: ${({ theme, border }) => border && '1px'};
  border-color: ${({ theme, border }) => border && `${theme.colors.neutral50}`};
  border-style: ${({ border }) => (border ? 'solid' : 'none')};
  border-radius: ${({ theme, clear }) => !clear && theme.spacings[2]};
`;

export const ListWrapper = styled.div`
  width: 100%;
  border-radius: ${({ theme, type }) =>
    ['Dos', 'Donts'].includes(type) ? theme.spacings[2] : '0'};
  border-color: ${({ theme, type }) =>
    ['Dos', 'Donts'].includes(type) ? theme.colors.neutral50 : 'transparent'};
  border-style: ${({ type }) =>
    ['Dos', 'Donts'].includes(type) ? 'solid' : 'none'};
  border-width: ${({ type }) =>
    ['Dos', 'Donts'].includes(type) ? '2px' : '0'};
  background: ${({ theme, type }) =>
    type === 'Dos'
      ? theme.colors.secondaryLight
      : type === 'Donts'
      ? theme.colors.primaryLight
      : 'none'};
  display: flex;
  flex-direction: column;
  padding: ${({ theme, type }) =>
    ['Dos', 'Donts'].includes(type) ? theme.spacings[6] : 0};
  margin-bottom: ${({ theme }) => theme.spacings[6]};
`;

export const AsideWrapper = styled.div`
  padding-right: ${({ theme }) => theme.spacings[4]};
  border-right: 1px solid ${({ theme }) => theme.colors.neutral30};
  ${({ theme }) => theme.media.mobile} {
    border-right: 0;
  }
`;
